package ch.randm.playsit.routing

import routing._

object ContactApi {

  val Submit = Method.POST / "contact" / "submit"

}
